var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.7897 4.22007C16.8297 1.27007 12.0297 1.27007 9.08966 4.22007C7.01966 6.27007 6.39966 9.22007 7.19966 11.8201L2.49966 16.5201C2.16966 16.8601 1.93966 17.5301 2.00966 18.0101L2.30966 20.1901C2.41966 20.9101 3.08966 21.5901 3.80966 21.6901L5.98966 21.9901C6.46966 22.0601 7.13966 21.8401 7.47966 21.4901L8.29966 20.6701C8.49966 20.4801 8.49966 20.1601 8.29966 19.9601L6.35966 18.0201C6.06966 17.7301 6.06966 17.2501 6.35966 16.9601C6.64966 16.6701 7.12966 16.6701 7.41966 16.9601L9.36966 18.9101C9.55966 19.1001 9.87966 19.1001 10.0697 18.9101L12.1897 16.8001C14.7797 17.6101 17.7297 16.9801 19.7897 14.9301C22.7397 11.9801 22.7397 7.17007 19.7897 4.22007ZM14.4997 12.0001C13.1197 12.0001 11.9997 10.8801 11.9997 9.50007C11.9997 8.12007 13.1197 7.00007 14.4997 7.00007C15.8797 7.00007 16.9997 8.12007 16.9997 9.50007C16.9997 10.8801 15.8797 12.0001 14.4997 12.0001Z",
    fill: "#F66962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12C15.8807 12 17 10.8807 17 9.5C17 8.11929 15.8807 7 14.5 7C13.1193 7 12 8.11929 12 9.5C12 10.8807 13.1193 12 14.5 12Z",
    fill: "#F66962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.c9d0565a525489548f4989448315cfa7.svg";
export { ForwardRef as ReactComponent };